import sithMesInventoryItemReceive101List from "@/views/sithMes/inventory/SithMesInventoryItemReceive101List";
import sithMesInventoryItemReceive103List from "@/views/sithMes/inventory/SithMesInventoryItemReceive103List";
import sithMesInventoryItemReceive105List from "@/views/sithMes/inventory/SithMesInventoryItemReceive105List";
import sithMesInventoryInspectionDeliveryTaskList from "@/views/sithMes/inventory/SithMesInventoryInspectionDeliveryTaskList";
import sithMesInventoryOrderDeliveryTaskList from "@/views/sithMes/inventory/SithMesInventoryOrderDeliveryTaskList";
import sithMesInventoryDn400DeliveryTaskList from "@/views/sithMes/inventory/SithMesInventoryDn400DeliveryTaskList";
import sithMesInventoryPartsDeliveryTaskList from "@/views/sithMes/inventory/SithMesInventoryPartsDeliveryTaskList";
import sithMesInventoryOrderDeliveryTaskEdit from "@/views/sithMes/inventory/SithMesInventoryOrderDeliveryTaskEdit";
import sithMesInventoryProductsStorageInputList from "@/views/sithMes/inventory/SithMesInventoryProductsStorageInputList"
import sithMesInventoryPurchaseStorageInputList from "@/views/sithMes/inventory/SithMesInventoryPurchaseStorageInputList"
import sithMesInventoryChangeProjectDetailList from "@/views/sithMes/inventory/SithMesInventoryChangeProjectDetailList.vue";
import sithMesInventoryChangeProjectDetailEdit from "@/views/sithMes/inventory/SithMesInventoryChangeProjectDetailEdit.vue";
import sithMesInventoryTransportMonitor from "@/views/sithMes/inventory/SithMesInventoryTransportMonitor.vue";


const metaObject = {
    requiresAuth: true,
    roles: ['mmf']
};

export default [{
    path: "/sithMes/inventory/sithMesInventoryItemReceive101List",
    name: "sithMesInventoryItemReceive101List",
    component: sithMesInventoryItemReceive101List,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryItemReceive103List",
    name: "sithMesInventoryItemReceive103List",
    component: sithMesInventoryItemReceive103List,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryItemReceive105List",
    name: "sithMesInventoryItemReceive105List",
    component: sithMesInventoryItemReceive105List,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryInspectionDeliveryTaskList",
    name: "sithMesInventoryInspectionDeliveryTaskList",
    component: sithMesInventoryInspectionDeliveryTaskList,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryOrderDeliveryTaskList",
    name: "sithMesInventoryOrderDeliveryTaskList",
    component: sithMesInventoryOrderDeliveryTaskList,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryOrderDeliveryTaskEdit",
    name: "sithMesInventoryOrderDeliveryTaskEdit",
    component: sithMesInventoryOrderDeliveryTaskEdit,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryDn400DeliveryTaskList",
    name: "sithMesInventoryDn400DeliveryTaskList",
    component: sithMesInventoryDn400DeliveryTaskList,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryPartsDeliveryTaskList",
    name: "sithMesInventoryPartsDeliveryTaskList",
    component: sithMesInventoryPartsDeliveryTaskList,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryProductsStorageInputList",
    name: "sithMesInventoryProductsStorageInputList",
    component: sithMesInventoryProductsStorageInputList,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryPurchaseStorageInputList",
    name: "sithMesInventoryPurchaseStorageInputList",
    component: sithMesInventoryPurchaseStorageInputList,
    meta: metaObject
},{
    path: "/sithMes/inventory/sithMesInventoryTransportMonitor",
    name: "sithMesInventoryTransportMonitor",
    component: sithMesInventoryTransportMonitor,
    meta: metaObject
}

]